
export const errors_map = {
    'NL': {
        'PR': 'Foutieve inhoud ingevoerd. Als het probleem zich blijft voordoen, neem dan contact met ons op. Error code:',
        'NE': 'Netwerk error, controleer alstublieft uw internet connectie. Als het probleem zich blijft voordoen, neem dan contact met ons op. Error code:',
        'SE': 'Server niet bereikbaar, probeer het later nog een keer. Als het probleem zich blijft voordoen, neem dan contact met ons op. Error code:',
        'OB': 'Object error, probeer het later nog een keer. Als het probleem zich blijft voordoen, neem dan contact met ons op. Error code:',
        'OB_UG': 'Error, het is niet mogelijk om meerdere partners aan een enkele gebruiker toe te voegen.',
        'DB': 'Database error, probeer het later nog een keer. Als het probleem zich blijft voordoen, neem dan contact met ons op. Error code:',
        'DA_001':'Error, controleer de ingevoerde naam!',
        'DA_002':'Error, het ingevoerde emailadres en wachtwoord horen niet bij elkaar!',
        'DA_003':'Error, Jouw emailadres bestaat al in ons system! Probeer met jouw inloggegevens in te loggen',
        'OB_033':'Error, de ingevoerde partner bestaat al in ons systeem!',
        'TL':"Error, Je kan niet een trip verwijderen die al gestart is"
    },
    'EN': {
        'PR': 'Wrong content provided. If the problem persists, please contact us. Error code:',
        'NE': 'Network error, check your internet connection. If the problem persists, please contact us. Error code:',
        'SE': 'Server not reachable error, please try again later. If the problem persists, please contact us. Error code:',
        'OB': 'Object error, please try again later. If the problem persists, please contact us. Error code:',
        'OB_UG': 'It is not possible to add multiple partners to a single user.',
        'DB': 'Database error, please try again later. If the problem persists, please contact us. Error code:',
        'DA_001':'Error duplicated name!',
        'DA_002':'Error, the email and password do not match!',
        'DA_003':'Error, your email exists in our system! Try to login instead',
        'OB_033':'Error, this partner already exists in the system!',
        'TL':"Error, you can't delete a trip which is already started"
    }
};
